package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.layout.Surface

@Composable
internal fun Spacer(modifier: Modifier = Modifier) {
    Surface(modifier) {}
}